import { FunctionComponent, Suspense, lazy } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { t } from '@/utils/i18n';
import { getParams, isCYOMode } from '@/utils/params';
import { Button } from '@/components/common/Button';
import { Modal, ModalContent, ModalTypes } from '@/components/common/modal/modal';
import './CheckoutSuccess.scss';

const ComplementaryProducts = lazy(
  () =>
    import(
      /* webpackChunkName: 'complementary-products', webpackPrefetch: true */ './ComplementaryProducts'
    )
);

export const ComplementaryProductsPlaceholder = () => (
  <div className="complementary-products complementary-products__placeholder" />
);

export const AsyncCheckoutSuccess: FunctionComponent = () => {
  const navigate = useNavigate();
  const checkoutSuccessOpen = Boolean(useMatch('/checkout'));
  const params = getParams();

  const onClose = () => {
    navigate('/');
  };

  const openBasket = () => {
    if (params.openBasket) {
      params.openBasket(null, (err?: unknown) => {
        if (err) {
          console.log(err);
        } else {
          //add tracking
          onClose();
        }
      });
    } else {
      new Error('Basket implementation not configured correctly, openBasket missing!');
    }
  };

  return (
    <Modal
      open={checkoutSuccessOpen}
      onClose={onClose}
      type={ModalTypes.dialog}
      className="checkout-success__modal"
    >
      <ModalContent flex>
        <h3 className="checkout-success__headline">{t('basketDialog.headline')}</h3>
        <div className="checkout-success__buttons">
          <Button onClick={onClose}>{t('basketDialog.nextProduct')}</Button>
          <Button onClick={openBasket} className="sprd-button--light">
            {t('basketDialog.toBasket')}
          </Button>
        </div>
        {isCYOMode() && (
          <Suspense fallback={<ComplementaryProductsPlaceholder />}>
            <ComplementaryProducts />
          </Suspense>
        )}
      </ModalContent>
    </Modal>
  );
};
